import { URLS } from 'services/constant-urls';

export const skinStickerImage = (src: string) => `${URLS.urlStickers}${src}`;
